import Submit from "./submit";
import Table from "./table";
import HeatmapLink from "./heatmaplink";
import {EvalFormat} from "./evalformat";


async function loadFromDomScript(queryDomElement) {

    const response = await Submit.submit(queryDomElement.innerText, "data/topn");

    // dimensionless queries have no dimension, so to get the data into the right "shape"
    // we need to zip the headers and the rows
    let dataMode = queryDomElement.getAttribute("data-mode");
    if (dataMode === "dimensionless") {
        function zip(a, b) {
            return a.map(function(e, i) {
                return [e, b[i]];
            });
        }
        response.rows = zip(response.headers, response.rows[0]);
        response.prior = zip(response.headers, response.prior[0]);
    }

    // get row formatter
    let innerText = queryDomElement
        .parentNode
        .querySelector("script[type='row/formatter']")
        .innerText;

    function getRowKey(row) {
        // stringify because we can't have arrays as keys
        return JSON.stringify(row.slice(0, -1));
    }

    function getRowValue(row) {
        return row[row.length - 1];
    }

    function buildFrequencyMap(rows) {
        const map = new Map();
        for (let i=0;i<rows.length;++i) {
            const key = getRowKey(rows[i]);
            const value = getRowValue(rows[i]);
            map.set(key, value);
        }

        return map;
    }

    const priorFreqMap = buildFrequencyMap(response.prior);

    // these are out here so we can eval the row-transformer once and reuse it
    let key = null;
    let value = null;
    let priorValue = null;
    let max = Math.max(...response.rows.map(row => getRowValue(row)));


    function delta() {
        if (isNaN(priorValue) || priorValue === 0)
            return `<span class="percent-change no-change">&nbsp;--&nbsp;</span>`;

        let result = Math.abs((priorValue - value))/((priorValue + value)/2) * 100;
        result =  result.toFixed(0);

        if (!isFinite(result))
            result = "&infin;";
        else
            result = result + "%";

        if (value > priorValue)
            return `<span class="percent-change up"><i class="fa-solid fa-arrow-up"></i>${result}</span>`
        else
            return `<span class="percent-change down"><i class="fa-solid fa-arrow-down"></i>${result}</span>`
    }

    function bgPercent(content) {
        let percent = (value/max)*100;
        return `<div class="stats-bg-percent" style="--width: ${percent}%;">${content}</div>`
    }

    // accessible within eval scripts
    let fmt = EvalFormat;

    let rowTransformer = eval("(" + innerText + ")");

    let rows = [];
    response.rows.forEach((row) => {
        key = getRowKey(row);
        value = getRowValue(row);
        priorValue = priorFreqMap.get(key)||0;
        rows.push(rowTransformer(row));
    });

    // if the row formatter returns false don't display anything.  KPIs will be all false
    let allRowsFalse = rows.every(r => r === false);

    if (rows.length === 0 || !allRowsFalse) {

        let contentBox = queryDomElement.closest(".content-box");
        let chartNoData = contentBox.querySelector(".chart-no-data");
        let table = contentBox.querySelector("table");
        if (rows.length === 0) {
            // display no data message
            chartNoData.style.display = "block";

            if (table != null)
                table.remove();
        } else {
            chartNoData.style.display = "none";
            function installClickHandlers(table) {
                HeatmapLink.installClickHandler(table);
            }
            Table.createTable(queryDomElement, rows, [], installClickHandlers);
        }

    }
    /*
    //console.log(rows.length + "  ..  " + allRowsFalse)
    //if (!allRowsFalse)
    //    Table.createTable(queryDomElement, rows);
    */
}

const DashboardTopN = {
    "loadFromDomScript": loadFromDomScript
};

export default DashboardTopN;